<template>
  <a-drawer
    width="60%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-page-header
        title="基础信息"
        sub-title="Basic information"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="设备名称"
              prop="deviceName"
            >
              <a-input
                v-model="form.deviceName"
                placeholder="请输入设备名称"
                :maxLength="20"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="设备编号"
              prop="deviceCode"
            >
              <a-input
                v-model="form.deviceCode"
                oninput="value=value.replace(/[^A-Za-z0-9]/g,'')"
                placeholder="请输入设备编号"
                :maxLength="30"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="IOT编号"
              prop="iotCode"
            >
              <a-input
                v-model="form.iotCode"
                placeholder="请输入IOT编号"
                :maxLength="30"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="位置描述"
              prop="locationDescription"
            >
              <a-input
                v-model="form.locationDescription"
                placeholder="请输入位置描述"
                :maxLength="50"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="所属管线"
              prop="pipelineId"
            >
              <div class="customUser_id">
                <a-select
                  v-model="form.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  @change="pipelineIdChange"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in pipelineList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
                <a-icon
                  type="plus-circle"
                  class="customUser_t"
                  @click="$refs.pipelineForm.handleAdd()"
                />
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="客户名称"
              prop="customUserId"
            >
              <div class="customUser_id">
                <a-select
                  v-model="form.customUserId"
                  placeholder="请选择客户名称"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in customList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.companyName }}
                  </a-select-option>
                </a-select>
                <a-icon
                  type="plus-circle"
                  class="customUser_t"
                  @click="$refs.userForm.handleAdd()"
                  :hidden="userAddHidden"
                />
              </div>

            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="客户购买日期"
              prop="purchaseDate"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.purchaseDate"
                show-time
                type="date"
                placeholder="请选择客户购买日期"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="阴保数据告警"
              prop="dataAlarm"
            >
              <a-input
                v-model="form.dataAlarm"
                placeholder="请输入阴保数据告警"
                :maxLength="30"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="设备出错状态"
              prop="errorState"
            >
              <a-select
                v-model="form.errorState"
                placeholder="请选择设备出错状态"
              >
                <a-select-option :value="0">正常</a-select-option>
                <a-select-option :value="1">电压不足</a-select-option>
                <a-select-option :value="2">流量不足</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="生产厂商"
              prop="manufacturer"
            >
              <a-input
                v-model="form.manufacturer"
                placeholder="请输入生产厂商"
                :maxLength="30"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="生产批号"
              prop="batchNumber"
            >
              <a-input
                v-model="form.batchNumber"
                placeholder="请输入生产批号"
                :maxLength="40"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="试片面积"
              prop="deviceTypeId"
            >
              <div class="customUser_id">
                <a-select
                  v-model="form.deviceTypeId"
                  placeholder="请选择试片面积"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in deviceTypeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <a-icon
                  type="plus-circle"
                  class="customUser_t"
                  @click="$refs.deviceType.handleAdd()"
                />
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="干扰类型"
              prop="interferenceTypeId"
            >
              <div class="customUser_id">
                <a-select
                  v-model="form.interferenceTypeId"
                  placeholder="请选择干扰类型"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in interferenceTypeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <a-icon
                  type="plus-circle"
                  class="customUser_t"
                  @click="$refs.typeFrom.handleAdd()"
                />
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="设备分类"
              prop="deviceCategorizeId"
            >
              <div class="customUser_id">
                <a-select
                  v-model="form.deviceCategorizeId"
                  placeholder="请选择设备分类"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in deviceCategorizeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
<!--                <a-icon-->
<!--                  type="plus-circle"-->
<!--                  class="customUser_t"-->
<!--                  @click="$refs.deviceCategorize.handleAdd()"-->
<!--                />-->
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="备注"
              prop="remark"
            >
              <a-input
                type='textarea'
                v-model="form.remark"
                placeholder="请输入备注"
                :maxLength="100"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <a-page-header
        title="安装维护"
        sub-title="Installation And Maintenance"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="安装人"
              prop="installer"
            >
              <a-input
                v-model="form.installer"
                placeholder="请输入安装人"
                :maxLength="20"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="安装时间"
              prop="installationTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.installationTime"
                show-time
                placeholder="请选择安装时间"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="所处经度"
              prop="longitude"
            >
              <a-input-number
                v-model="form.longitude"
                style='width: 100%;'
                placeholder="请输入所处经度"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="所处纬度"
              prop="latitude"
            >
              <a-input-number
                v-model="form.latitude"
                style='width: 100%;'
                placeholder="请输入所处纬度"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="维护人"
              prop="maintenancePersonnel"
            >
              <a-input
                v-model="form.maintenancePersonnel"
                placeholder="请输入维护人"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="责任人"
              prop="personResponsible"
            >
              <a-input
                v-model="form.personResponsible"
                placeholder="请输入责任人"
                :maxLength="20"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <a-page-header
        title="设备自我申报"
        sub-title="Equipment self declaration"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="获取设备运行参数时间"
              prop="runParamTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.runParamTime"
                show-time
                placeholder="请选择获取设备运行参数时间"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col><a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="运行时间（S）"
              prop="runTimeSeconds"
            >
              <a-input-number
                v-model="form.runTimeSeconds"
                :min="0"
                style='width: 100%;'
                placeholder="请输入运行时间"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="设置通断周期（S）"
              prop="onOffCycleSeconds"
            >
              <a-input-number
                v-model="form.onOffCycleSeconds"
                :min="0"
                style='width: 100%;'
                placeholder="请输入设置通断周期"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="4G上传周期（S）"
              prop="uploadCycleSeconds4g"
            >
              <a-input-number
                v-model="form.uploadCycleSeconds4g"
                :min="0"
                style='width: 100%;'
                placeholder="请输入4G上传周期"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="断电间隔（MS）"
              prop="powerOutageIntervalMillisecond"
            >
              <a-input-number
                v-model="form.powerOutageIntervalMillisecond"
                :min="0"
                style='width: 100%;'
                placeholder="请输入断电间隔"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="通电延时（MS）"
              prop="powerOnDelayMillisecond"
            >
              <a-input-number
                v-model="form.powerOnDelayMillisecond"
                :min="0"
                style='width: 100%;'
                placeholder="请输入通电延时"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="断电延时（MS）"
              prop="offDelayOperationMillisecond"
            >
              <a-input-number
                v-model="form.offDelayOperationMillisecond"
                :min="0"
                style='width: 100%;'
                placeholder="请输入断电延时"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="低功耗采集（S）"
              prop="lowPowerAcquisitionMinute"
            >
              <a-input-number
                v-model="form.lowPowerAcquisitionMinute"
                :min="0"
                style='width: 100%;'
                placeholder="请输入低功耗采集"
                :maxLength="20"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="报警电压高限位（V）"
              prop="alarmVoltageHighLimit"
            >
              <a-input-number
                v-model="form.alarmVoltageHighLimit"
                :min="0"
                style='width: 100%;'
                :maxLength="20"
                placeholder="请输入报警电压高限位"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="报警电压低限位（V）"
              prop="alarmVoltageLowLimit"
            >
              <a-input-number
                v-model="form.alarmVoltageLowLimit"
                :min="0"
                :maxLength="20"
                style='width: 100%;'
                placeholder="请输入报警电压低限位"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="所处经度"
              prop="deviceLongitude"
            >
              <a-input-number
                v-model="form.deviceLongitude"
                style='width: 100%;'
                placeholder="请输入所处经度"
                :maxLength="20"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="所处纬度"
              prop="deviceLatitude"
            >
              <a-input-number
                v-model="form.deviceLatitude"
                style='width: 100%;'
                :maxLength="20"
                placeholder="请输入所处纬度"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="经纬度时间"
              prop="longitudeAndLatitudeTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.longitudeAndLatitudeTime"
                show-time
                placeholder="请选择经纬度时间"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col><a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="最近接收数据"
              prop="lastReceivedDataTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.lastReceivedDataTime"
                show-time
                placeholder="请选择最近接收数据"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item
              label="最近数据"
              prop="recentData"
            >
              <a-input
                type="textarea"
                v-model="form.recentData"
                placeholder="请输入最近数据"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item
              label="修正后数据"
              prop="revisedData"
            >
              <a-input
                type="textarea"
                v-model="form.revisedData"
                placeholder="请输入修正后数据"
                :maxLength="50"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <a-page-header
        title="SIM卡信息"
        sub-title="SIM card information"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="电话号码"
              prop="phoneNumber"
            >
              <a-input
                v-model="form.phoneNumber"
                placeholder="请输入电话号码"
                :maxLength="11"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="iccid编号"
              prop="iccidCode"
            >
              <a-input
                v-model="form.iccidCode"
                placeholder="请输入iccid编号"
                :maxLength="30"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="供应商"
              prop="supplier"
            >
              <a-select
                v-model="form.supplier"
                placeholder="请选择供应商"
              >
                <a-select-option :value="1">移动</a-select-option>
                <a-select-option :value="2">联调</a-select-option>
                <a-select-option :value="3">电信</a-select-option>
                <a-select-option :value="4">歌华</a-select-option>
                <a-select-option :value="5">其它</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="本月流量（MB）"
              prop="trafficThisMonth"
            >
              <a-input-number
                v-model="form.trafficThisMonth"
                :min="0"
                style='width: 100%;'
                :trafficThisMonth="3"
                :maxLength="30"
                placeholder="请输入本月流量"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="到期日期"
              prop="dueDate"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.dueDate"
                show-time
                placeholder="请选择到期日期"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col><a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="最近获取时间"
              prop="recentAcquisitionTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="form.recentAcquisitionTime"
                show-time
                placeholder="请选择最近获取时间"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <userForm
      ref="userForm"
      @ok="getCustomList"
    ></userForm>
    <pipelineForm
      ref="pipelineForm"
      @ok="getPipelineList"
    ></pipelineForm>
    <typeFrom
      ref="typeFrom"
      @ok="getInterferenceTypeList"
    ></typeFrom>
    <deviceCategorize
      ref="deviceCategorize"
      @ok="getDeviceCategorizeList"
    ></deviceCategorize>
    <deviceType
      ref="deviceType"
      @ok="getDeviceTypeList"
    ></deviceType>
  </a-drawer>
</template>

<script>
import { getDevice, addDevice, updateDevice, listPipeline, customList, listDeviceCategorize, listDeviceType, listInterferenceType } from '@/api/saifuneng/recorder'
import userForm from '../../../biz/user/modules/CreateForm.vue'
import pipelineForm from '../../pipeline/modules/CreateForm.vue'
import typeFrom from '../../interferencetype/modules/CreateForm.vue'
import deviceCategorize from '../../devicecategorize/modules/CreateForm.vue'
import deviceType from '../../devicetype/modules/CreateForm.vue'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    userForm,
    pipelineForm,
    typeFrom,
    deviceCategorize,
    deviceType
  },
  data () {
    return {
      userAddHidden: true,
      submitLoading: false,
      formTitle: '',
      pipelineList: [],
      customList: [],
      deviceCategorizeList: [],
      deviceTypeList: [],
      interferenceTypeList: [],
      // 表单参数
      form: {
        id: null,
        deviceName: null,
        deviceCode: null,
        pipelineId: undefined,
        customUserId: undefined,
        iotCode: null,
        locationDescription: null,
        purchaseDate: null,
        dataAlarm: null,
        errorState: undefined,
        manufacturer: null,
        batchNumber: null,
        deviceCategorizeId: undefined,
        deviceTypeId: undefined,
        interferenceTypeId: undefined,
        installer: null,
        installationTime: null,
        longitude: null,
        latitude: null,
        maintenancePersonnel: null,
        personResponsible: null,
        runParamTime: null,
        runTimeSeconds: null,
        onOffCycleSeconds: null,
        uploadCycleSeconds4g: null,
        powerOutageIntervalMillisecond: null,
        powerOnDelayMillisecond: null,
        offDelayOperationMillisecond: null,
        lowPowerAcquisitionMinute: null,
        alarmVoltageHighLimit: null,
        alarmVoltageLowLimit: null,
        longitudeAndLatitudeTime: null,
        deviceLongitude: null,
        deviceLatitude: null,
        lastReceivedDataTime: null,
        recentData: null,
        revisedData: null,
        phoneNumber: null,
        iccidCode: null,
        supplier: undefined,
        dueDate: null,
        trafficThisMonth: null,
        recentAcquisitionTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' }
        ],
        phoneNumber: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur'
          }
        ],
        locationDescription: [{ required: true, message: '请输入位置描述', trigger: 'blur' }],
        deviceCode: [
          { required: true, message: '设备编号不能为空', trigger: 'blur' }
        ],
        deviceCategorizeId: [
          { required: true, message: '设备分类不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getPipelineList()
    this.getDeviceCategorizeList()
    this.getDeviceTypeList()
    this.getInterferenceTypeList()
    this.getCustomList(null)
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceName: null,
        deviceCode: null,
        pipelineId: undefined,
        customUserId: undefined,
        iotCode: null,
        locationDescription: null,
        purchaseDate: null,
        dataAlarm: null,
        errorState: undefined,
        manufacturer: null,
        batchNumber: null,
        deviceCategorizeId: undefined,
        deviceTypeId: undefined,
        interferenceTypeId: undefined,
        installer: null,
        installationTime: null,
        longitude: null,
        latitude: null,
        maintenancePersonnel: null,
        personResponsible: null,
        runParamTime: null,
        runTimeSeconds: null,
        onOffCycleSeconds: null,
        uploadCycleSeconds4g: null,
        powerOutageIntervalMillisecond: null,
        powerOnDelayMillisecond: null,
        offDelayOperationMillisecond: null,
        lowPowerAcquisitionMinute: null,
        alarmVoltageHighLimit: null,
        alarmVoltageLowLimit: null,
        longitudeAndLatitudeTime: null,
        deviceLongitude: null,
        deviceLatitude: null,
        lastReceivedDataTime: null,
        recentData: null,
        revisedData: null,
        phoneNumber: null,
        iccidCode: null,
        supplier: undefined,
        dueDate: null,
        trafficThisMonth: null,
        recentAcquisitionTime: null,
        remark: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      if (this.$store.getters.roles.includes('admin')) {
        this.userAddHidden = false
      }
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      if (this.$store.getters.roles.includes('admin')) {
        this.userAddHidden = false
      }
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDevice({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDevice(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDevice(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    getDeviceCategorizeList () {
      listDeviceCategorize().then(response => {
        this.deviceCategorizeList = response.data
      })
    },
    getDeviceTypeList () {
      listDeviceType().then(response => {
        this.deviceTypeList = response.data
      })
    },
    getInterferenceTypeList () {
      listInterferenceType().then(response => {
        this.interferenceTypeList = response.data
      })
    },
    getPipelineList () {
      let query = {
        pageNum: 1,
        pageSize: 1,
      }
      listPipeline(query).then(response => {
        this.pipelineList = response.data
      })
    },
    pipelineIdChange (value) {
      this.getCustomList(value)
      this.form.customUserId = undefined
    },
    getCustomList (pipelineId) {
      let query = {
        "pipelineId": pipelineId,
        pageNum: 1,
        pageSize: 9999,
        userType: '04'
      }
      customList(query).then(response => {
        this.customList = response.data.records
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }


  }
}
</script>
<style lang="less" scoped>
.ant-page-header {
  display: block !important;
}

.customUser_id {
  display: flex;
  align-items: center;

  .customUser_t {
    font-size: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
